import { render, staticRenderFns } from "./inlandRiverEmbargo.vue?vue&type=template&id=6d38b3e4&scoped=true"
import script from "./inlandRiverEmbargo.vue?vue&type=script&lang=js"
export * from "./inlandRiverEmbargo.vue?vue&type=script&lang=js"
import style0 from "./inlandRiverEmbargo.vue?vue&type=style&index=0&id=6d38b3e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38b3e4",
  null
  
)

export default component.exports